var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalicAlpahbet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6V8.25H12.1575L9.5925 14.25H7.5V16.5H13.5V14.25H11.8425L14.4075 8.25H16.5V6H10.5Z",
    fill: "#8897AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicAlpahbet);
export default __webpack_public_path__ + "static/media/italic-alpahbet.df282791f3ad309742b51fc99d6eab5e.svg";
export { ForwardRef as ReactComponent };